import React, { Component, Button } from 'react';
import DropdownTreeSelectContainer from './DropDownContainer'
import { CategoryCreatorPopup } from './CreatorPopup/CategoryCreatorPopup';
import 'react-dropdown-tree-select/dist/styles.css'


export class CategorySelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            categoryData: {
                label: 'loading...',
                value: 'loading...',
                isDefaultValue: true,
                disabled: true,
                children: []
            }
        };
    }

    static defaultProps = {
        onSelection: (id) => { },
        defaultValue: null
    }

    componentDidMount() {
        this.populateCategoryList();
    }

    async populateCategoryList() {
        const response = await fetch(`api/category/list-tree?defaultValue=${this.props.defaultValue}`);
        const data = await response.json();
        this.setState({ categoryData: data});
    }

    onChange = (currentNode, selectedNodes) => {
        if (selectedNodes.length > 0) {
            this.props.onSelection(selectedNodes[0].value);
        }
        else
        {
            this.props.onSelection(0);
        }
    }

    render() {
        const onSubmit = () => {
            this.populateCategoryList();
        };

        return (
            <div>
                <div style={{ display: 'inline-block' }}>
                    <DropdownTreeSelectContainer data={this.state.categoryData} onChange={this.onChange} mode={'radioSelect'} />
                </div>
                <div style={{ display: 'inline-block', verticalAlign: 'top', paddingLeft: "5px" }}>
                    {this.props.allowCreate &&
                        <CategoryCreatorPopup triggerText={"Create New"} onSubmit={onSubmit} />}
                </div>
            </div>
        );
    }
}
